import { CellComponentRequestJSON } from "./../questionPage/Cell-Component-Request.JSON";

export class CellComponentDetailRequestJSON {
    questionOptionID: Number;
    questionColumnID: Number;
    cellTrackerID: Number;
    questionID: Number;
    hasLinkedQuestion: boolean;
    isCellLevelValidationActivated: boolean;
    isMandatoryValidationActivated: boolean;
    isVisibleValidationActivated: boolean;
    rowIndexForTrackingCellIndex: Number;
    columnIndexForTrackingCellIndex: Number;
    cellComponentJSON: CellComponentRequestJSON;

    constructor(){
        this.cellComponentJSON=new CellComponentRequestJSON;
    }
}